<template>
  <div
    :class="{
      'btn-row': true,
      'space-between': spaceBetween,
      'space-around': spaceAround,
      block,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ButtonsRow",
  props: {
    spaceBetween: {
      type: Boolean,
      default: false,
    },
    spaceAround: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-row {
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.space-between {
    justify-content: space-between;
  }

  &.space-around {
    justify-content: space-around;
  }

  &.block {
    width: 100%;
  }

  .v-btn {
    margin: 0 15px;
  }

  a {
    margin: 0 10px;
    padding: 6px 8px;
    min-width: 130px;
  }
}
</style>
